/** High-contrast chrome for the standalone ICS-205A form on dark IAP panels. */

export const ICS205A_OUTLINE_BTN =
  'tw:border-neutral-500 tw:bg-neutral-900 tw:text-white tw:hover:bg-neutral-800';

export const ICS205A_ICON_BTN = 'tw:text-white! tw:hover:bg-neutral-800';

export const ICS205A_TRASH_BTN =
  'tw:text-red-500! tw:hover:text-red-400! tw:disabled:text-red-500/40!';

export const ICS205A_INPUT =
  'tw:w-full tw:min-w-0 tw:rounded-md tw:border tw:border-neutral-500 tw:bg-neutral-900 tw:px-2 tw:py-1.5 tw:text-xs tw:text-white tw:outline-none tw:placeholder:text-neutral-400';

export const ICS205A_SECTION =
  'tw:rounded-md tw:border tw:border-neutral-700 tw:bg-neutral-900/60 tw:p-3';

export const ICS205A_SECTION_LABEL =
  'tw:mb-1 tw:text-[10px] tw:font-semibold tw:uppercase tw:tracking-wide tw:text-neutral-400';

export const ICS205A_SECTION_VALUE =
  'tw:text-sm tw:text-white tw:whitespace-pre-wrap';
